export enum TankersGroupType {
    Spot = 0,
    Period = 1,
}

export const tankersGroupTypes = [
    {
        id: TankersGroupType.Spot,
        value: 'Spot',
        label: 'Spot',
    },
    {
        id: TankersGroupType.Period,
        value: 'Period',
        label: 'Period',
    },
];

export const spotValue = tankersGroupTypes[0].value;
export const periodValue = tankersGroupTypes[1].value;

export const getTankersGroupTypeByValue = (value) =>
    tankersGroupTypes.find(
        (x) => value && x.value.toLowerCase() === value.toLowerCase()
    );

export function parseTankersGroupType(
    input: string | number | undefined | null
): TankersGroupType | undefined {
    if (input === null || input === undefined) {
        return undefined;
    }

    if (typeof input === 'number') {
        if (
            input === TankersGroupType.Spot ||
            input === TankersGroupType.Period
        ) {
            return input as TankersGroupType;
        }
        return undefined;
    }

    if (typeof input === 'string') {
        const matched = tankersGroupTypes.find(
            (x) => x.value.toLowerCase() === input.toLowerCase()
        );
        return matched?.id;
    }

    return undefined;
}

export default tankersGroupTypes;
